// LocalStorage-based data store (swap for API later)
const KEYS = {
  USERS: 'sl_users',
  CURRENT_USER: 'sl_current_user',
  ASSIGNMENTS: 'sl_assignments',
  FLOWCHARTS: 'sl_flowcharts',
  DOCUMENTS: 'sl_documents',
  CONTACTS: 'sl_contacts',
  OWNERSHIP: 'sl_ownership',
  DEALS: 'sl_deals',
  OFFERS: 'sl_offers',
  BUYERS: 'sl_buyers',
  PACKAGES: 'sl_packages',
  CLOSINGS: 'sl_closings',
  CLOSING_TASKS: 'sl_closing_tasks',
  STR_PRICING: 'sl_str_pricing',
};

function get(key) {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}

function set(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

// Seed default admin user
function seedDefaults() {
  const users = get(KEYS.USERS);
  if (!users || users.length === 0) {
    // No default users seeded in production — use Supabase Auth
    set(KEYS.USERS, []);
  }
  if (!get(KEYS.ASSIGNMENTS)) set(KEYS.ASSIGNMENTS, []);
  if (!get(KEYS.FLOWCHARTS)) set(KEYS.FLOWCHARTS, []);
  if (!get(KEYS.DOCUMENTS)) set(KEYS.DOCUMENTS, []);

  if (!get(KEYS.CONTACTS)) set(KEYS.CONTACTS, [
    // Demo companies
    { id: 'cco-001', type: 'company', name: 'Permian Basin Energy LLC', entityType: 'LLC', email: 'info@permianbasin.com', phone: '432-555-0200', address: '456 W Wall St', city: 'Midland', state: 'TX', zip: '79701', notes: 'Primary customer', createdAt: new Date().toISOString() },
    { id: 'cco-002', type: 'company', name: 'Mesa Land Company', entityType: 'LP', email: 'contact@mesaland.com', phone: '806-555-0300', address: '789 Mesa Rd', city: 'Amarillo', state: 'TX', zip: '79101', notes: '', createdAt: new Date().toISOString() },
    { id: 'cco-003', type: 'company', name: 'Bureau of Land Management', entityType: 'Government', email: 'blm@interior.gov', phone: '202-555-0100', address: '1849 C St NW', city: 'Washington', state: 'DC', zip: '20240', notes: 'Federal agency', createdAt: new Date().toISOString() },
    // Demo people
    { id: 'cper-001', type: 'person', firstName: 'John', lastName: 'Butler', fullName: 'John D. Butler', companyId: '', companyName: '', title: '', email: 'jbutler@example.com', phone: '432-555-0101', address: '100 Butler Rd', city: 'Pecos', state: 'TX', zip: '79772', notes: 'Heir of Thomas Spell Survey', createdAt: new Date().toISOString() },
    { id: 'cper-002', type: 'person', firstName: 'Mary', lastName: 'Ragsdale', fullName: 'M.E.A. Ragsdale', companyId: '', companyName: '', title: '', email: 'ragsdale@example.com', phone: '432-555-0102', address: '200 Reeves County Rd', city: 'Pecos', state: 'TX', zip: '79772', notes: '', createdAt: new Date().toISOString() },
    { id: 'cper-003', type: 'person', firstName: 'Thomas', lastName: 'Shamburger', fullName: 'Thos. J. Shamburger', companyId: '', companyName: '', title: '', email: '', phone: '', address: '', city: 'Pecos', state: 'TX', zip: '79772', notes: '', createdAt: new Date().toISOString() },
    { id: 'cper-004', type: 'person', firstName: 'Sarah', lastName: 'Mitchell', fullName: 'Sarah Mitchell', companyId: 'cco-001', companyName: 'Permian Basin Energy LLC', title: 'Land Manager', email: 'sarah@permianbasin.com', phone: '432-555-0103', address: '456 W Wall St', city: 'Midland', state: 'TX', zip: '79701', notes: '', createdAt: new Date().toISOString() },
  ]);

  if (!get(KEYS.OWNERSHIP)) set(KEYS.OWNERSHIP, [
    {
      id: 'own-demo-001',
      assignmentId: 'asgn-demo-001',
      updatedAt: new Date().toISOString(),
      surface: [
        { id: 'se-001', contactId: 'cco-003', contactName: 'Bureau of Land Management', contactType: 'company', interestType: 'Fee Simple', fraction: '1/1', decimal: 1.0, acres: '320', tract: 'Thomas Spell Survey 372, A-890', effectiveDate: '1850-01-01', status: 'Former', notes: 'Original sovereign grant' },
        { id: 'se-002', contactId: 'cper-001', contactName: 'John D. Butler', contactType: 'person', interestType: 'Fee Simple', fraction: '1/1', decimal: 1.0, acres: '320', tract: 'Thomas Spell Survey 372, A-890', effectiveDate: '1884-06-15', status: 'Former', notes: 'Deed 33/587' },
        { id: 'se-003', contactId: 'cco-001', contactName: 'Permian Basin Energy LLC', contactType: 'company', interestType: 'Fee Simple', fraction: '1/1', decimal: 1.0, acres: '320', tract: 'Thomas Spell Survey 372, A-890', effectiveDate: '2024-01-01', status: 'Current', notes: 'Current surface owner of record' },
      ],
      mineral: [
        { id: 'me-001', contactId: 'cper-001', contactName: 'John D. Butler', contactType: 'person', interestType: 'NPRI', fraction: '1/16', decimal: 0.0625, acres: '163.2', tract: 'Thomas Spell Survey 372, A-890', effectiveDate: '1884-06-15', status: 'Current', notes: 'Non-participating royalty interest reserved in Deed 33/587' },
        { id: 'me-002', contactId: 'cper-002', contactName: 'M.E.A. Ragsdale', contactType: 'person', interestType: 'NRI', fraction: '1/4', decimal: 0.25, acres: '163.2', tract: 'Thomas Spell Survey 372 — N/2', effectiveDate: '1896-09-10', status: 'Current', notes: 'Deed 34/376' },
        { id: 'me-003', contactId: 'cper-003', contactName: 'Thos. J. Shamburger', contactType: 'person', interestType: 'NRI', fraction: '1/4', decimal: 0.25, acres: '20', tract: 'Thomas Spell Survey 372 — partial', effectiveDate: '1896-05-20', status: 'Current', notes: 'Deed 34/376 — 1/2 interest, 20 acres' },
        { id: 'me-004', contactId: 'cco-001', contactName: 'Permian Basin Energy LLC', contactType: 'company', interestType: 'WI', fraction: '1/2', decimal: 0.5, acres: '320', tract: 'Thomas Spell Survey 372, A-890', effectiveDate: '2024-01-01', status: 'Current', notes: 'Operator working interest' },
      ],
      workingInterest: [
        { id: 'wi-001', contactId: 'cco-001', contactName: 'Permian Basin Energy LLC', contactType: 'company', interestType: 'WI', wiPercent: '75.000000', nriPercent: '65.625000', operator: true, tract: 'Thomas Spell Survey 372, A-890', effectiveDate: '2024-01-01', status: 'Current', notes: 'Operator — primary W/I owner' },
        { id: 'wi-002', contactId: 'cco-002', contactName: 'Mesa Land Company', contactType: 'company', interestType: 'WI', wiPercent: '25.000000', nriPercent: '21.875000', operator: false, tract: 'Thomas Spell Survey 372, A-890', effectiveDate: '2024-03-15', status: 'Current', notes: 'Non-op working interest partner' },
      ],
    },
  ]);
}

export const store = {
  KEYS,
  get,
  set,
  seedDefaults,

  // Users
  getUsers: () => get(KEYS.USERS) || [],
  addUser: (user) => {
    const users = get(KEYS.USERS) || [];
    users.push(user);
    set(KEYS.USERS, users);
  },
  updateUser: (id, updates) => {
    const users = get(KEYS.USERS) || [];
    const idx = users.findIndex((u) => u.id === id);
    if (idx !== -1) {
      users[idx] = { ...users[idx], ...updates };
      set(KEYS.USERS, users);
    }
  },
  deleteUser: (id) => {
    const users = (get(KEYS.USERS) || []).filter((u) => u.id !== id);
    set(KEYS.USERS, users);
  },

  // Assignments
  getAssignments: () => get(KEYS.ASSIGNMENTS) || [],
  addAssignment: (a) => {
    const items = get(KEYS.ASSIGNMENTS) || [];
    items.push(a);
    set(KEYS.ASSIGNMENTS, items);
  },
  updateAssignment: (id, updates) => {
    const items = get(KEYS.ASSIGNMENTS) || [];
    const idx = items.findIndex((a) => a.id === id);
    if (idx !== -1) {
      items[idx] = { ...items[idx], ...updates };
      set(KEYS.ASSIGNMENTS, items);
    }
  },
  deleteAssignment: (id) => {
    const items = (get(KEYS.ASSIGNMENTS) || []).filter((a) => a.id !== id);
    set(KEYS.ASSIGNMENTS, items);
    // Cascade: remove related ownership, flowcharts, and documents
    set(KEYS.OWNERSHIP, (get(KEYS.OWNERSHIP) || []).filter(o => o.assignmentId !== id));
    set(KEYS.FLOWCHARTS, (get(KEYS.FLOWCHARTS) || []).filter(f => f.assignmentId !== id));
    set(KEYS.DOCUMENTS, (get(KEYS.DOCUMENTS) || []).filter(d => d.assignmentId !== id));
  },

  // Flowcharts
  getFlowcharts: () => get(KEYS.FLOWCHARTS) || [],
  addFlowchart: (f) => {
    const items = get(KEYS.FLOWCHARTS) || [];
    items.push(f);
    set(KEYS.FLOWCHARTS, items);
  },
  updateFlowchart: (id, updates) => {
    const items = get(KEYS.FLOWCHARTS) || [];
    const idx = items.findIndex((f) => f.id === id);
    if (idx !== -1) {
      items[idx] = { ...items[idx], ...updates };
      set(KEYS.FLOWCHARTS, items);
    }
  },

  // Documents
  getDocuments: () => get(KEYS.DOCUMENTS) || [],
  // Parity with supabaseStore so pages that call the richer document
  // API don't crash when running against local storage.
  getAllDocuments: () => get(KEYS.DOCUMENTS) || [],
  getDocumentCount: async () => (get(KEYS.DOCUMENTS) || []).length,
  searchDocuments: async (query = '') => {
    const trimmed = String(query || '').trim().toLowerCase();
    if (trimmed.length < 2) return [];
    return (get(KEYS.DOCUMENTS) || []).filter((d) => (
      ['name', 'grantor', 'grantee', 'volume', 'page', 'instrumentNo', 'instrumentTitle', 'legalDescription', 'originalFilename']
        .some((field) => String(d?.[field] || '').toLowerCase().includes(trimmed))
    ));
  },
  addDocument: (d) => {
    const items = get(KEYS.DOCUMENTS) || [];
    items.push(d);
    set(KEYS.DOCUMENTS, items);
  },
  updateDocument: (id, updates) => {
    const items = get(KEYS.DOCUMENTS) || [];
    const idx = items.findIndex((d) => d.id === id);
    if (idx !== -1) {
      items[idx] = { ...items[idx], ...updates };
      set(KEYS.DOCUMENTS, items);
    }
  },
  deleteDocument: (id) => {
    const items = get(KEYS.DOCUMENTS) || [];
    set(KEYS.DOCUMENTS, items.filter((d) => d.id !== id));
  },

  // Contacts
  getContacts: () => get(KEYS.CONTACTS) || [],
  addContact: (c) => { const items = get(KEYS.CONTACTS) || []; items.push(c); set(KEYS.CONTACTS, items); },
  updateContact: (id, updates) => {
    const items = get(KEYS.CONTACTS) || [];
    const idx = items.findIndex(c => c.id === id);
    if (idx !== -1) { items[idx] = { ...items[idx], ...updates }; set(KEYS.CONTACTS, items); }
  },
  deleteContact: (id) => { set(KEYS.CONTACTS, (get(KEYS.CONTACTS) || []).filter(c => c.id !== id)); },

  // Ownership
  getOwnership: () => get(KEYS.OWNERSHIP) || [],
  getOwnershipByAssignment: (assignmentId) => (get(KEYS.OWNERSHIP) || []).find(o => o.assignmentId === assignmentId) || null,
  saveOwnership: (record) => {
    const items = get(KEYS.OWNERSHIP) || [];
    const idx = items.findIndex(o => o.id === record.id);
    if (idx !== -1) { items[idx] = record; } else { items.push(record); }
    set(KEYS.OWNERSHIP, items);
  },
  deleteOwnership: (id) => { set(KEYS.OWNERSHIP, (get(KEYS.OWNERSHIP) || []).filter(o => o.id !== id)); },

  // Deals
  getDeals: () => get(KEYS.DEALS) || [],
  getDealFull: (id) => (get(KEYS.DEALS) || []).find(d => d.id === id) || null,
  addDeal: (d) => { const items = get(KEYS.DEALS) || []; items.push(d); set(KEYS.DEALS, items); },
  updateDeal: (id, updates, options = {}) => {
    const items = get(KEYS.DEALS) || [];
    const idx = items.findIndex(d => d.id === id);
    if (idx === -1) throw new Error('updateDeal: Deal not found');
    if (options.expectedUpdatedAt && items[idx].updatedAt && items[idx].updatedAt !== options.expectedUpdatedAt) {
      throw new Error('updateDeal: Deal changed before this save completed. Refresh the deal and review the latest changes before saving again.');
    }
    items[idx] = { ...items[idx], ...updates, updatedAt: new Date().toISOString() };
    set(KEYS.DEALS, items);
    return items[idx];
  },
  deleteDeal: (id) => { set(KEYS.DEALS, (get(KEYS.DEALS) || []).filter(d => d.id !== id)); },

  // Offers
  getOffers: () => get(KEYS.OFFERS) || [],
  addOffer: (o) => { const items = get(KEYS.OFFERS) || []; items.push(o); set(KEYS.OFFERS, items); },
  updateOffer: (id, updates) => {
    const items = get(KEYS.OFFERS) || [];
    const idx = items.findIndex(o => o.id === id);
    if (idx !== -1) { items[idx] = { ...items[idx], ...updates }; set(KEYS.OFFERS, items); }
  },
  deleteOffer: (id) => { set(KEYS.OFFERS, (get(KEYS.OFFERS) || []).filter(o => o.id !== id)); },

  // Buyers
  getBuyers: () => get(KEYS.BUYERS) || [],
  addBuyer: (b) => { const items = get(KEYS.BUYERS) || []; items.push(b); set(KEYS.BUYERS, items); },
  updateBuyer: (id, updates) => {
    const items = get(KEYS.BUYERS) || [];
    const idx = items.findIndex(b => b.id === id);
    if (idx !== -1) { items[idx] = { ...items[idx], ...updates }; set(KEYS.BUYERS, items); }
  },
  deleteBuyer: (id) => { set(KEYS.BUYERS, (get(KEYS.BUYERS) || []).filter(b => b.id !== id)); },

  // Packages
  getPackages: () => get(KEYS.PACKAGES) || [],
  addPackage: (p) => { const items = get(KEYS.PACKAGES) || []; items.push(p); set(KEYS.PACKAGES, items); },
  updatePackage: (id, updates) => {
    const items = get(KEYS.PACKAGES) || [];
    const idx = items.findIndex(p => p.id === id);
    if (idx !== -1) { items[idx] = { ...items[idx], ...updates }; set(KEYS.PACKAGES, items); }
  },
  deletePackage: (id) => { set(KEYS.PACKAGES, (get(KEYS.PACKAGES) || []).filter(p => p.id !== id)); },

  // Closings
  getClosings: () => get(KEYS.CLOSINGS) || [],
  addClosing: (c) => { const items = get(KEYS.CLOSINGS) || []; items.push(c); set(KEYS.CLOSINGS, items); },
  updateClosing: (id, updates) => {
    const items = get(KEYS.CLOSINGS) || [];
    const idx = items.findIndex(c => c.id === id);
    if (idx !== -1) { items[idx] = { ...items[idx], ...updates }; set(KEYS.CLOSINGS, items); }
  },
  deleteClosing: (id) => { set(KEYS.CLOSINGS, (get(KEYS.CLOSINGS) || []).filter(c => c.id !== id)); },

  // Closing Tasks
  getClosingTasks: () => get(KEYS.CLOSING_TASKS) || [],
  addClosingTask: (t) => { const items = get(KEYS.CLOSING_TASKS) || []; items.push(t); set(KEYS.CLOSING_TASKS, items); },
  updateClosingTask: (id, updates) => {
    const items = get(KEYS.CLOSING_TASKS) || [];
    const idx = items.findIndex(t => t.id === id);
    if (idx !== -1) { items[idx] = { ...items[idx], ...updates }; set(KEYS.CLOSING_TASKS, items); }
  },
  deleteClosingTask: (id) => { set(KEYS.CLOSING_TASKS, (get(KEYS.CLOSING_TASKS) || []).filter(t => t.id !== id)); },

  // STR Pricing (shared pricing map)
  getSTRPricingData: () => get(KEYS.STR_PRICING) || null,
  upsertSTRPricing: (entry) => {
    const items = get(KEYS.STR_PRICING) || [];
    const key = entry.tract
      ? `${entry.section}-${entry.township}-${entry.range}:${entry.tract}`
      : `${entry.section}-${entry.township}-${entry.range}`;
    const idx = items.findIndex(r => r.id === key);
    const record = { id: key, section: entry.section, township: entry.township, range: entry.range, tract: entry.tract || null, price: entry.price, updatedAt: new Date().toISOString() };
    if (idx !== -1) { items[idx] = record; } else { items.push(record); }
    set(KEYS.STR_PRICING, items);
  },
  deleteSTRPricing: (id) => { set(KEYS.STR_PRICING, (get(KEYS.STR_PRICING) || []).filter(r => r.id !== id)); },

  // Flowchart delete (missing from original)
  deleteFlowchart: (id) => { set(KEYS.FLOWCHARTS, (get(KEYS.FLOWCHARTS) || []).filter(f => f.id !== id)); },
};
